export default function () {
      return {
        terminalList:[],
      }
    }